// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7745":"3ecfc7cf","9378":"3ecfc7cf"}[chunkId] + ".chunk.css";
};